import React, { useState } from 'react';
import _ from 'lodash';
import { Box, Typography } from '@mui/material';
import { FormInputSelect } from 'components/form';

export function SelectFieldSetting({ settings, itemConfiguration, setItemConfiguration }: any) {
  const [value, setValue] = useState(_.get(itemConfiguration, settings.configurationKey, settings?.defaultValue ?? ''));

  const updateValue = (value: any) => {
    setValue(value);
    setItemConfiguration((prevItemConfiguration: any) => {
      return {
        ...prevItemConfiguration,
        [settings.configurationKey]: value,
      };
    });
  };

  return (
    <Box>
      <FormInputSelect
        value={value}
        onChange={updateValue}
        label={settings?.selectLabel}
        options={settings.options ?? []}
        variant={settings?.variant ?? 'standard'}
        slotProps={{
          select: {
            displayEmpty: settings?.displayEmpty,
          },
          inputLabel: settings?.displayEmpty
            ? {
                shrink: true,
              }
            : undefined,
        }}
      />
      {settings?.helperText && (
        <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0.5 }}>
          {settings.helperText}
        </Typography>
      )}
    </Box>
  );
}
